import * as React from 'react';
import { ColorBox, IconRow, InfoColumn, Title } from './_styles';
import stateSettings from '@state/settings';
import { changeProperty } from '@src/actions';
import { getSelectedNode } from '@src/utils';
const changeFontColor = (colorId) => () => {
    changeProperty('fontColorId', colorId);
};
const FontColorMutator = () => {
    const component = getSelectedNode();
    return (React.createElement(React.Fragment, null,
        React.createElement(InfoColumn, null,
            React.createElement(Title, null, "Color"),
            React.createElement(IconRow, null, stateSettings.colors.map((color) => (React.createElement(ColorBox, { key: color.id, selected: component.fontColorId === color.id, title: color.name, color: color.hex, onClick: changeFontColor(color.id) })))))));
};
export default FontColorMutator;
